export default __webpack_public_path__ + "static/media/mobmenu.b05e2a4f.svg";